var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNgLogoLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    width: 24,
    height: 24,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#00D563",
    d: "M1.45,23.85c-0.71-0.01-1.29-0.58-1.3-1.3V1.48c0-0.52,0.33-1,0.81-1.18C1.45,0.11,2,0.23,2.37,0.59l7.74,7.67 c0.52,0.52,0.52,1.33,0,1.81c-0.52,0.52-1.33,0.52-1.82,0L2.78,4.56v17.96C2.74,23.26,2.19,23.85,1.45,23.85z M22.56,23.85 c-0.33,0-0.67-0.15-0.93-0.37l-7.7-7.7c-0.52-0.52-0.52-1.33,0-1.81c0.52-0.52,1.33-0.52,1.81,0l5.52,5.52V1.52 c0-0.7,0.59-1.3,1.3-1.3s1.3,0.59,1.3,1.3v21.07c0,0.52-0.33,1-0.81,1.18C22.88,23.82,22.72,23.85,22.56,23.85L22.56,23.85z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgLogoLoader);
export default __webpack_public_path__ + "static/media/ng_logo_loader.25f08e5b08ea838415a574436e90ca96.svg";
export { ForwardRef as ReactComponent };